import { CoreState } from '../../../models';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class SetHasTabbedMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.setHasTabbed]: (localState: CoreState, hasTabbed: boolean) => {
      localState.hasTabbed = hasTabbed;
    }
  };
}
